export default {
  props: {
    budgetEntities: {
      type: Array,
      required: true
    }
  }
}
